'use client';

import type { FC } from 'react';
import { Modal, ModalContent } from '@paypoteam/ui-components/Modal';
import { P } from '@paypoteam/ui-components/P';
import { Spinner } from '@paypoteam/ui-components/Spinner';
import parse from 'html-react-parser';

import { useCssDimensions } from '@/utils/hooks/useCssDimensions';

import { ButtonsFactory } from '@/components/molecules/ButtonsFactory';
import DesktopTable from '@/components/organisms/TableModal/components/DesktopTable';
import MobileTable from '@/components/organisms/TableModal/components/MobileTable';
import type { TableModalProps } from '@/components/organisms/TableModal/TableModal.types';

const TableModal: FC<TableModalProps> = ({
    isVisible,
    isLoading,
    hasError,
    tableData,
    config,
}) => {
    const {
        description,
        noDataMessage,
        errorMessage,
        onOpenChange,
        footerProps,
        ...modalProps
    } = config;

    const { minWidthLg } = useCssDimensions();

    return (
        <Modal
            open={isVisible}
            onOpenChange={onOpenChange}
        >
            <ModalContent
                customFooter={
                    <ButtonsFactory
                        {...footerProps}
                        reverseOnMobile={false}
                        className="self-end md:w-fit"
                    />
                }
                className="max-h-fit"
                {...modalProps}
            >
                {isLoading ? (
                    <div className="relative h-[400px] w-full">
                        <Spinner />
                    </div>
                ) : hasError ? (
                    <P className="text-center">{parse(errorMessage)}</P>
                ) : tableData?.rows?.length ? (
                    <div className="flex flex-col gap-y-6">
                        <P>{description}</P>

                        {minWidthLg ? (
                            <DesktopTable
                                {...tableData}
                                className="hidden lg:table"
                            />
                        ) : (
                            <MobileTable
                                {...tableData}
                                className="table lg:hidden"
                            />
                        )}
                    </div>
                ) : (
                    <P>{parse(noDataMessage)}</P>
                )}
            </ModalContent>
        </Modal>
    );
};

export default TableModal;
